const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { home: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = { home: {} };
    }

    // 支持 export default 和 export const home = {...} 两种写法
    const data = (module.default as Record<string, string>) || (module.home as Record<string, string>) || (module as Record<string, string>);
    if (typeof data === 'object' && data !== null) {
      messages[lang].home = {
        ...messages[lang].home,
        ...data,
      };
    }
  }
});

export default messages;